import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import Axios from "../../axios/axios";
import imageCompression from "browser-image-compression";

const CreatePackage = () => {
  const [uploading, setUploading] = useState(false);
  const [name, setName] = useState("");
  const [packageproduct, setPackageProduct] = useState([]);
  const [photo, setPhoto] = useState("");

  const [price, setPrice] = useState("");
  const [offerPrice, setOfferPrice] = useState("");
  const [discount, setDiscount] = useState("");
  const [packageCode, setPackageCode] = useState("");

  const [loader, setLoader] = useState(false);

  const navigate = useNavigate();

  const { products } = useSelector((state) => state.productList);

  useEffect(() => {
    setPrice(totalPrice); // Update the price state
  }, [packageproduct, products]);

  // Calculate the total price by summing up the offerPrice of each selected product
  // Calculate the total price by summing up the offerPrice of each selected product
  const totalPrice = packageproduct.reduce((acc, productId) => {
    // Find the product by its ID in the products list
    const selectedProduct = products.find((p) => p._id === productId._id); // Assuming packageproduct contains product IDs
    if (selectedProduct) {
      return acc + (selectedProduct.offerPrice || 0) * productId.quantity; // Add offerPrice to the accumulator
    }
    return acc;
  }, 0);

  const submitHandler = async (e) => {
    e.preventDefault();
    setLoader(true);

    const data = {
      name,
      packageCode,
      product: packageproduct.map((item) => ({
        productId: item._id,
        quantity: item.quantity,
      })),
      photo,
      price,
      specialPrice: offerPrice,
      discount: price - offerPrice,
    };
    console.log(data, "package daa");
    try {
      const res = await Axios.post("/api/package", data);
      if (res.status === 201) {
        toast.success("Package created successfully!");
        setLoader(false);
        navigate("/package/view");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Error creating package");

      setLoader(false);
    }
  };

  const uploadFileHandler = async (e, val) => {
    console.log("uploading");

    const file = e.target.files[0];

    // Set up image compression options
    const options = {
      maxSizeMB: 0.2,
      maxWidthOrHeight: 800,
      useWebWorker: true,
    };

    try {
      // Compress the image
      const compressedFile = await imageCompression(file, options);
      const formData = new FormData();
      formData.append("image", compressedFile);
      setUploading(true);

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      const { data } = await Axios.post("/api/upload", formData, config);

      if (val === "photo") {
        setPhoto(data);
      }
      setUploading(false);
    } catch (error) {
      console.error(error);
      setUploading(false);
    }
  };

  const [errors, setErrors] = useState({});

  return (
    <div className="row">
      <div class="col-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Create Package</h4>
            <form class="forms-sample" onSubmit={submitHandler}>
              <div class="form-group">
                <label for="exampleInputName">Package Name</label>
                <input
                  type="text"
                  class="form-control"
                  onChange={(e) => setName(e.target.value)}
                  placeholder="package name"
                  value={name}
                  required={true}
                />
              </div>
              <div className="form-group">
                <label>Package Code</label>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Package Code"
                  value={packageCode}
                  onChange={(e) => setPackageCode(e.target.value.toUpperCase())}
                  required
                />
              </div>

              <div class="form-group">
                <label for="exampleInputPriority4">Photo</label>

                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => uploadFileHandler(e, "photo")}
                />
              </div>
              <img
                src={
                  photo === ""
                    ? process.env.PUBLIC_URL + "/images/select_image.png"
                    : `${photo}`
                }
                height="100"
              />
              <div class="form-group">
                <label for="exampleInputPriority4">Products</label>
                <select
                  className="form-control"
                  value={packageproduct}
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    const product = products.find((p) => p._id === selectedId);
                    if (
                      product &&
                      !packageproduct.some((p) => p._id === selectedId)
                    ) {
                      setPackageProduct([
                        ...packageproduct,
                        {
                          ...product,
                          quantity: 1,
                        },
                      ]);
                    }
                  }}
                  required={true}
                >
                  <option value="" disabled>
                    Select a Product
                  </option>
                  {products?.map((data) => (
                    <option value={data?._id}>{data?.name}</option>
                  ))}
                </select>
              </div>
              <div className="mt-3">
                <h6>Selected Products</h6>
                {packageproduct.length === 0 ? (
                  <p>No products selected.</p>
                ) : (
                  <ul className="list-group">
                    {packageproduct.map((item, index) => (
                      <li
                        key={item._id}
                        className="list-group-item d-flex justify-content-between align-items-center"
                      >
                        <span>
                          {item.name} - <strong>Quantity:</strong>
                        </span>
                        <input
                          type="number"
                          className="form-control quantity-input"
                          value={item.quantity}
                          min="1"
                          onChange={(e) => {
                            const updatedProducts = packageproduct.map((p) =>
                              p._id === item._id
                                ? {
                                    ...p,
                                    quantity: parseInt(e.target.value, 10) || 1,
                                  }
                                : p,
                            );
                            setPackageProduct(updatedProducts);
                          }}
                          style={{ width: "70px" }}
                        />
                        <button
                          type="button"
                          className="btn btn-danger btn-sm ml-2"
                          onClick={() =>
                            setPackageProduct(
                              packageproduct.filter((p) => p._id !== item._id),
                            )
                          }
                        >
                          Remove
                        </button>
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              <div class="form-group">
                <label for="exampleInputName">Price</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Price"
                  value={price}
                  required={true}
                  disabled
                  // onChange={(e) => setPrice(e.target.value)}
                />
              </div>
              <div class="form-group">
                <label for="exampleInputName">Special Price</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Special Price"
                  value={offerPrice}
                  onChange={(e) => setOfferPrice(e.target.value)}
                />
              </div>

              <hr />

              {loader ? (
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden"></span>
                </div>
              ) : (
                <div className="bottom-area">
                  <p className="mt-14"></p>
                  <button type="submit" class="btn btn-primary mr-2">
                    Submit
                  </button>
                  <Link to="/package/view">
                    <button class="btn btn-light">Cancel</button>
                  </Link>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreatePackage;
